import Icon from 'veui/components/Icon'
import { IconTextSquare } from 'dls-icons-vue'

Icon.register('text-square', IconTextSquare)
